var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-dialog",
        {
          ref: "dialog",
          attrs: {
            persistent: false,
            "no-esc-dismiss": false,
            "no-backdrop-dismiss": "",
            "content-class": {
              customDialog: true,
              "full-dialog": _vm.param.isFull,
              "mini-dialog": !_vm.param.isFull,
            },
            "content-style": { opacity: _vm.bodyOpacity },
            position: "top",
          },
          on: { show: _vm.onShow, hide: _vm.onHide },
          model: {
            value: _vm.param.visible,
            callback: function ($$v) {
              _vm.$set(_vm.param, "visible", $$v)
            },
            expression: "param.visible",
          },
        },
        [
          _c(
            "q-layout",
            {
              ref: "dialog-layout",
              staticClass: "bg-white no-scroll dialog-layout",
              style: {
                "max-width": _vm.param.isFull ? "none" : _vm.param.width,
                "min-height": "auto",
                "max-height": _vm.param.isFull ? "98%" : "calc(100vh - 60px)",
              },
              attrs: { view: "Lhh lpR fff" },
            },
            [
              _c(
                "q-header",
                {
                  ref: "dialog-header",
                  staticClass: "text-white dialog-header",
                  class: _vm.param.isFull
                    ? _vm.param.isApproval
                      ? "bg-mini-dialog cursor-move"
                      : "bg-full-dialog"
                    : "bg-mini-dialog cursor-move",
                },
                [
                  _c(
                    "q-toolbar",
                    { ref: "toolbar-header" },
                    [
                      _c(
                        "q-toolbar-title",
                        [
                          _vm._v(_vm._s(_vm.$label(_vm.param.title)) + " "),
                          _vm.param.suffixChip
                            ? _c(
                                "q-chip",
                                {
                                  attrs: {
                                    outline: "",
                                    square: "",
                                    dense: "",
                                    color: "white",
                                    "text-color": "main-custom",
                                    icon: "bookmark",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.param.suffixChip) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.regUserInfo.regUserName
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                flat: "",
                                round: "",
                                dense: "",
                                icon: "info",
                              },
                            },
                            [
                              _c(
                                "q-tooltip",
                                {
                                  attrs: {
                                    anchor: "bottom middle",
                                    self: "top end",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "tooltip-layer" }, [
                                    _vm.regUserInfo.regUserName
                                      ? _c(
                                          "div",
                                          { staticClass: "tooltip-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$label("LBL0000714") +
                                                  " " +
                                                  _vm.regUserInfo.regUserName +
                                                  (_vm.regUserInfo
                                                    .regUserDeptName
                                                    ? "/" +
                                                      _vm.regUserInfo
                                                        .regUserDeptName
                                                    : "")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.regUserInfo.regUserName
                                      ? _c(
                                          "div",
                                          { staticClass: "tooltip-content" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.regUserInfo.regDtStrTime
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("br"),
                                    _vm.regUserInfo.chgUserName
                                      ? _c(
                                          "div",
                                          { staticClass: "tooltip-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$label("LBL0000715") +
                                                  " " +
                                                  _vm.regUserInfo.chgUserName +
                                                  (_vm.regUserInfo
                                                    .chgUserDeptName
                                                    ? "/" +
                                                      _vm.regUserInfo
                                                        .chgUserDeptName
                                                    : "")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.regUserInfo.chgUserName
                                      ? _c(
                                          "div",
                                          { staticClass: "tooltip-content" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.regUserInfo.chgDtStrTime
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.param.isFull
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                flat: "",
                                round: "",
                                dense: "",
                                icon: _vm.screenIcon,
                                size: "12px",
                              },
                              on: { click: _vm.setFullScreen },
                            },
                            [
                              _c(
                                "q-tooltip",
                                { staticClass: "bg-white text-primary" },
                                [_vm._v(_vm._s(_vm.screenIconText))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            dense: "",
                            icon: "close",
                          },
                          on: { click: _vm.closePopup },
                        },
                        [
                          _c(
                            "q-tooltip",
                            { staticClass: "bg-white text-primary" },
                            [_vm._v(_vm._s(_vm.$label("LBL0000520")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "q-page-container",
                {
                  staticClass: "custom-dialog-page-container",
                  style: {
                    "overflow-y": "auto",
                    "min-height": "auto",
                    "max-height":
                      _vm.param.isFull ||
                      _vm.param.width == "95%" ||
                      _vm.param.width == "99%"
                        ? "calc(100vh)"
                        : "calc(100vh - 100px)",
                  },
                },
                [
                  _c(
                    "q-page",
                    {
                      staticStyle: { "min-height": "200px" },
                      attrs: { padding: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          style: {
                            height: _vm.param.isFull
                              ? "calc(100vh - 70px)"
                              : _vm.param.width == "95%" ||
                                _vm.param.width == "99%"
                              ? "calc(100vh - 70px)"
                              : "auto",
                          },
                        },
                        [
                          _c(_vm.param.target, {
                            tag: "component",
                            style: `background:` + _vm.bodyColor,
                            attrs: {
                              popupParam: _vm.param.param,
                              contentHeight: _vm.contentHeight,
                              returnData: _vm.returnData,
                            },
                            on: {
                              setRegInfo: _vm.setRegInfo,
                              closePopup: _vm.param.closeCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }